import { FC, memo, useContext } from "react";
import { PointType } from "./LineChart.helpers";
import { LineChartThemeContext } from "./LineChartTheme.context";

const LineChartDot: FC<{
    cx: number;
    cy: number;
    color: string;
    type: PointType;
    isHovered?: boolean;
}> = (
    {
        cy,
        cx,
        color,
        type,
        isHovered = false,
    }
) => {
    const { THEME } = useContext(LineChartThemeContext);

    switch (type) {
        case PointType.Empty: {
            return (
                <>
                    {isHovered && (
                        <circle
                            cx={cx}
                            cy={cy}
                            r={6}
                            fill={color}
                            fillOpacity={0.3}
                            className="LineChart__point-back"
                        />
                    )}
                    <circle
                        cx={cx}
                        cy={cy}
                        r={isHovered ? 4 : 3}
                        stroke={color}
                        strokeWidth={isHovered ? 2 : 1}
                        fill={THEME.BACKGROUND.DEFAULT}
                        className="LineChart__point"
                    />
                </>
            );
        }
        case PointType.Solid: {
            return (
                <>
                    <circle
                        cx={cx}
                        cy={cy}
                        r={isHovered ? 6 : 5}
                        fill={color}
                        fillOpacity={isHovered ? 0.5 : 0.3}
                        className="LineChart__point-back"
                    />
                    <circle
                        cx={cx}
                        cy={cy}
                        r={isHovered ? 4 : 3}
                        fill={color}
                        className="LineChart__point"
                    />
                </>
            )
        }
        case PointType.Small: {
            return (
                <>
                    {isHovered && (
                        <circle
                            cx={cx}
                            cy={cy}
                            r={5}
                            fill={color}
                            fillOpacity={0.3}
                            className="LineChart__point-back"
                        />
                    )}
                    <circle
                        cx={cx}
                        cy={cy}
                        r={isHovered ? 3 : 2}
                        fill={color}
                        className="LineChart__point"
                    />
                </>
            )
        }
        default:
            return null;
    }

};

export default memo(LineChartDot);